import { Center, Spinner, VStack, Text, Box } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useUserStore } from '@store/app.store';

import { authorizeMicrosoftAsAdmin } from '@services/query-services/teams.query-service';

export default function TeamsConnectPage() {
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    const handleTeamsConnection = () => {
      if (!user) return;

      authorizeMicrosoftAsAdmin();
    };

    handleTeamsConnection();
  }, [user]);

  // Show loading state while processing
  return (
    <Box data-cy='teams-connect-page'>
      <Center pt={10}>
        <VStack gap={6}>
          <Text fontSize='lg'>Connecting to Teams...</Text>
          <Spinner size='xl' />
        </VStack>
      </Center>
    </Box>
  );
}
